import React from "react";
import { TitleSetup } from "../Datas/Functions/titleSetup";
import Banner from "../Components/Banner/Banner";
import ImageInfoBox from "../Components/ImageInfoBox/ImageInfoBox";
import NoticeAlert from "../Components/NoticeAlert/NoticeAlert";
import ItemSection from "../Components/ItemSection/ItemSection";
import { useState, useEffect, useContext } from "react";
import SliderBanner from "../Components/SliderBanner/SliderBanner";
import { useSiteData } from "../Contexts/SiteContext";
import SearchItemSection from "../Components/SearchItemSection/SearchItemSection";
import PopularProducts from "../Components/PopulerCard/PopularProducts";
import Last5Order from "../Components/Last5Order/Last5Order";

const Home = (meta) => {
  const { categories, setIsLoading } = useSiteData();

  const [showProducts, setShowProducts] = useState([]);

  useEffect(() => {
    setShowProducts(categories);
  }, [categories]);
  TitleSetup({ ...meta });
  return (
    <div className="w-full">
      <SearchItemSection />
      <SliderBanner />
      <NoticeAlert />
      {showProducts.length > 0 &&
        showProducts.map((prodCat, i) => (
          <ItemSection
            key={i}
            heading={prodCat.title}
            showAll={false}
            prods={prodCat.prods}
            showCount={5}
            badge={"Sales"}
          />
        ))}
      <PopularProducts />
      <Last5Order />
      <ImageInfoBox />
    </div>
  );
};

export default Home;
